// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"d759f6a3","404":"1090b581","648":"62e936d9","807":"dcd21c69"}[chunkId] + ".chunk.js";
};